import { inject, Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { RisikoOpkraevning } from '../risiko-opkraevning.model';
import { RisikoOpkraevningSearchParams } from './opkraevning-search/risiko-opkraevning-search-params.model';
import { SimpleApi } from '@core/api/simple.api';
import { RisikoOpkraevningStatus } from '../risiko-opkraevning-status.model';

@Injectable({
  providedIn: 'root',
})
export class RisikoOpkraevningDatasource extends TableDatasource<
  RisikoOpkraevning,
  RisikoOpkraevningSearchParams
> {
  endpoint = '/api/admin/risikoopkraevninger';
  defaultSortField = 'id';
  override defaultDescending = true;

  simpleApi = inject(SimpleApi);

  async getForloeb(risikoOpkraevningId: number) {
    return await this.simpleApi.getList<RisikoOpkraevningStatus>(
      this.endpoint + '/forloeb',
      { risikoOpkraevningId }
    );
  }

  async getHistorik(letsikringNr: string) {
    return await this.simpleApi.getList<RisikoOpkraevning>(
      this.endpoint + '/historik',
      { letsikringNr }
    );
  }
}
